import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../assets/img/bugzero/bz-navbar-logo.svg';

const BugZeroLogo = ({ height = 22 }) => (
  <img src={logo} alt="BugZero" className="bz-logo" style={{ height, width: 'auto', display: 'block' }} />
);

BugZeroLogo.propTypes = {
  height: PropTypes.number
};

export default BugZeroLogo;
